import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { STORE_PATH } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

/** 저장한 디자인이 없을 때 — 스토어에서 상품을 골라 디자인을 시작하게 이끈다. */
export const QuoteDesignEmpty = (): ReactElement => (
  <div className="flex flex-col items-center gap-5 border-y border-foreground/10 px-5 py-16 text-center sm:py-20">
    <div className="space-y-2">
      <p className="text-xl font-bold tracking-[-0.02em] sm:text-2xl">
        아직 저장한 디자인이 없어요
      </p>
      <p className="text-sm text-muted-foreground">
        상품을 골라 디자인을 저장하면 여기에서 바로 견적을 요청할 수 있어요.
      </p>
    </div>
    <Link to={STORE_PATH} className={cn(buttonVariants({ size: 'lg' }), 'mt-2 h-12 px-8')}>
      상품 고르러 가기
    </Link>
  </div>
);
